import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import { PageSubTitle, Text } from 'components/common/Elements/Elements';

import classes from './AdditionalContent.module.scss';

const AdditionalContent = ({ data }) => {
  const { t } = useTranslation(['activity']);
  return (
    <>
      <PageSubTitle title={data.name} className={classes.title} size={2} />
      <ul className={classes.children}>
        {data.tooltipData.length > 0 ? (
          data.tooltipData.map(item => (
            <li className={classes.labelInfoWrap} key={item.parameter}>
              <Text weight="b">
                {item.parameter !== 'Siem Integration'
                  ? item.parameter
                  : t('activity:customers.SIEM_INTEGRATION')}
              </Text>
              <Text
                className={
                  typeof item.value === 'boolean' &&
                  classes.labelInfoWrap_uppercase
                }
              >
                {item.value.toString()}
              </Text>
            </li>
          ))
        ) : (
          <li className={classes.labelInfoWrap}>
            <Text weight="b">No data</Text>
          </li>
        )}
      </ul>
    </>
  );
};

AdditionalContent.propTypes = {
  data: PropTypes.object
};

export default AdditionalContent;
